/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBarStackedVertical = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 20h20v2H2v-2zm14-8h6v6h-6v-6zm2 2v2h2v-2h-2zM9 8h6v10H9V8zm2 2v6h2v-6h-2zm-9 2h6v6H2v-6zM2 2h6v9H2V2zm2 12v2h2v-2H4zM4 4v5h2V4H4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartBarStackedVertical as ChartBarStackedVertical };
